import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; 
import logomuseu from "../../assets/logomuseu.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronDown } from "@fortawesome/free-solid-svg-icons";

// Mesma flag temporária usada em components/home/VirtualCollectionSection.js:
// a equipe ainda está cadastrando as fotografias do acervo iconográfico, então
// o link fica escondido no menu público até o cadastramento terminar. NÃO
// remova os botões/lógica abaixo — só troque para `true` quando publicar.
const ICONOGRAFIA_DISPONIVEL = false;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);

  // Verifica se está em qualquer página relacionada a acervo para manter o estilo
  const isAcervoActive = location.pathname.startsWith("/acervo") || location.pathname === "/acervos";

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    
    // Fechar dropdown ao clicar fora
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavigation = (path) => {
    setMenuOpen(false);
    setDropdownOpen(false);
    navigate(path);
  };

  return (
    <nav className={`navbar-museu ${isScrolled ? "scrolled" : ""} ${isAcervoActive ? "acervo-page" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => handleNavigation("/")}>
          <img src={logomuseu} alt="Museu" />
        </div>

        {/* Links desktop */}
        <div className="navbar-links">
          <button className="nav-link" onClick={() => handleNavigation("/")}>Início</button>
          
          {/* Dropdown Acervo */}
          <div className="nav-item-dropdown" ref={dropdownRef}>
            <button 
              className={`nav-link dropdown-toggle ${isAcervoActive ? "active" : ""}`}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              Acervo <FontAwesomeIcon icon={faChevronDown} className={`chevron ${dropdownOpen ? 'open' : ''}`} />
            </button>
            
            {dropdownOpen && (
              <div className="dropdown-menu-museu">
                <button onClick={() => handleNavigation("/acervo")}>Acervo de Equipamentos</button>
                {ICONOGRAFIA_DISPONIVEL && (
                  <button onClick={() => handleNavigation("/acervo-iconografico")}>Acervo Iconográfico</button>
                )}
              </div>
            )}
          </div>

          <button className="nav-link" onClick={() => handleNavigation("/creditos")}>Sobre</button>
          
          <Link to="/login" className="nav-admin">
            Acesso da Administração
          </Link>
        </div>

        {/* Botão mobile */}
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
        </button>
      </div>

      {/* Menu lateral mobile */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <button className="mobile-link" onClick={() => handleNavigation("/")}>Início</button>
        
        {/* No mobile, as opções do acervo aparecem indentadas ou em lista */}
        <div className="mobile-acervo-section">
            <p className="mobile-label">Acervos</p>
            <button className="mobile-link sub" onClick={() => handleNavigation("/acervo")}>Acervo de Equipamentos</button>
            {ICONOGRAFIA_DISPONIVEL && (
              <button className="mobile-link sub" onClick={() => handleNavigation("/acervo-iconografico")}>Acervo Iconográfico</button>
            )}
        </div>

        <button className="mobile-link" onClick={() => handleNavigation("/creditos")}>Sobre</button>
        <Link to="/login" className="mobile-admin">Acesso da Administração</Link>
      </div>
    </nav>
  );
};

export default Navbar;